export default __webpack_public_path__ + "assets/images/user_1.88fdfe1ad328b020eeb0df3b19370b7c.png";